import { render, staticRenderFns } from "./PopupErrors.vue?vue&type=template&id=48915f85"
import script from "./PopupErrors.vue?vue&type=script&lang=js"
export * from "./PopupErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports